import axios from '../utlis/interceptor'
import { BASE_URL , TOTAL_CHALLENGES, TOTAL_LIVE_COMPETITIONS, TOTAL_MONEY_COLLECTED } from "../resources/APIEndpoints";

function AnalyticsServices() {
    this.getMoneyCollected = (body) => axios.post(BASE_URL + TOTAL_MONEY_COLLECTED , body)
    this.getTotalLiveCompetition = (body) => axios.post(BASE_URL + TOTAL_LIVE_COMPETITIONS)
    this.getTotalChallenges = (body) => axios.post(BASE_URL + TOTAL_CHALLENGES, body)
}

export default new AnalyticsServices()